import { Injectable } from '@angular/core';
import { ApiService } from './api.service';
import { UiService } from './ui.service';
import { LoggerService } from './logger.service';
import { Config } from '../state-man/models/config.model';

@Injectable({
  providedIn: 'root'
})
export class ConfigService {

  private baseUrl: string = 'configs/'

  constructor(
    private apiService: ApiService,
    private uiService: UiService
  ) { 
  }

  public async getAppConfig () : Promise<Config | null> {      
    try {
      const ret = await this.apiService.apiReturnsAny('get', this.baseUrl + 'app/')           
      return ret ? Config.buildOne(ret) : null
    } 
    catch (error) {    
      LoggerService.log(error + this.baseUrl)   
      await this.uiService.showToast('An unexpected error occurred and has been sent to the support team (config).')      
      return null
    }
  }  
  
}
